import { render, staticRenderFns } from "./StudyPlan.vue?vue&type=template&id=2c2e5fdf&scoped=true"
import script from "./StudyPlan.vue?vue&type=script&lang=js"
export * from "./StudyPlan.vue?vue&type=script&lang=js"
import style0 from "./StudyPlan.vue?vue&type=style&index=0&id=2c2e5fdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2e5fdf",
  null
  
)

export default component.exports